import React, {useState, useEffect} from 'react';
import "./ExposureHistogram.css";
import { Bar } from "react-chartjs-2";

const LayerHistogram = (props) => {
    const {
        selectedAssetProperties,
        selectedPortfolio,
        selectedProject,
        layers,
     } = props;

    const [data, setData] = useState(null);

    useEffect(() => {  
        const findBin = (number, breaks) => {
            if (number < breaks[0]) {
                return [-1];
            }

            const result = Array(breaks.length);
            for (let i = 0; i < breaks.length - 1; i++) {
                if (number >= breaks[i] && number < breaks[i + 1]) {
                    result[i] = 1;
                    return result;
                }
            }

            result[breaks.length - 1] = 100;
            return result;
        };

        const createBins = (length, factor) => {
            let data = Array(length).fill().map(() => Math.min(Math.random()-factor, Math.random()+factor));
            const maxScore = Math.max(...data);
            const minScore = Math.min(...data);
            const binSize = (maxScore - minScore) / 10;
            let bins = new Array(10).fill(0);
            data.forEach((score) => {
            const binIndex = Math.min(Math.floor((score - minScore) / binSize), 9); 
            bins[binIndex]++;
            });
            let breaks = [];
            breaks.push(minScore);
            for (let i = 1; i < 10; i++) {
            breaks.push(minScore + i * binSize);
            }
            return [bins, breaks];
        };

        let bins = {};
        let layerData = {};
        layers.forEach((l) => {
            bins[l.key] = createBins(300, Math.random());
            let pointData = Math.min(Math.random(), Math.random());
    
            layerData[l.key] = {
                labels: bins[l.key][0].map(item => item),
                datasets: [
                    {
                        label: 'bin',
                        data: findBin(pointData, bins[l.key][1]),
                        backgroundColor: '#d00b0b',
                        type: 'scatter',
                        borderWidth: 3,
                        borderColor: '#d00b0b',
                    },
                    {
                        label: l.name,
                        data: bins[l.key][0],
                        backgroundColor: 'gray',
                        borderColor: '#fff',
                        borderWidth: 1,
                    },
                ],
            }
        });
        setData(layerData);
    }, [selectedAssetProperties, selectedPortfolio, selectedProject])

    const title_options = {
        maintainAspectRatio: false,
        indexAxis: 'x',
        style: {
            style: {
                height: '10px',
            }
        },
        scales: {
            x: {
              ticks: {
                display: false // This will hide the x-axis labels
              },
              grid: {
                display: true// Optional: also hide the grid lines
              }
            },
            y: {
              beginAtZero: false,
              ticks: {
                display: false // This will hide the y-axis labels
              },
              grid: {
                display: true // Optional: also hide the grid lines
              }
            }
          },
        plugins: { 
          legend: {
            display: false,
          },
          labels: {
            display: false,
            // usePointStyle: true,
          },
          title: {
            display: true,
            text: 'Distribution of Normalized Dataset Values Across Portfolio',
            color: 'gray',
            position:'top',
            font: {
              size: 16,
            }
          },
        },
    };

    const options = {
        maintainAspectRatio: false,
        indexAxis: 'x',
        style: {
            style: {
                height: '10px',
            }
        },
        scales: {
            x: {
              ticks: {
                display: false // This will hide the x-axis labels
              },
              grid: {
                display: true// Optional: also hide the grid lines
              }
            },
            y: {
                beginAtZero: false,
              ticks: {
                display: false // This will hide the y-axis labels
              },
              grid: {
                display: true // Optional: also hide the grid lines
              }
            }
          },
        plugins: {
            legend: {
                display: false,
            },
            labels: {
                display: false,
            },
        },
    };

    const bottomOptions = {
        maintainAspectRatio: false,
        indexAxis: 'x',
        style: {
            style: {
                height: '10px',
            }
        },
        scales: {
            x: {
              ticks: {
                display: true,
                callback: function(value, index, ticks) {
                    return '0.' + value;
                }
              },
              grid: {
                display: true// Optional: also hide the grid lines
              }
            },
            y: {
                beginAtZero: false,
              ticks: {
                display: false // This will hide the y-axis labels
              },
              grid: {
                display: true // Optional: also hide the grid lines
              }
            }
          },
        plugins: {
            legend: {
                display: false,
            },
            labels: {
                display: false,
            },
        },
    };

    let h = 240 / layers.length;
    const rows = data ? layers.map(
        (l, index) => {
            if (index === 0 ) return;
            if (index === layers.length - 1) return;
            return (
                <>
                    <div className='axis-label' key={l.key} style={{fontSize: ".8em"}}>{l.name}</div>
                    <div style={{ height: h }}>
                        <Bar data={data[l.key]} options={options}/>
                    </div>
                </>
            )
        }
    ) : <></>;

    return data && (
        <div style={{display: 'grid', gridTemplateColumns: '15% 1fr', height: '100%'}}>
            <div className='axis-label' style={{fontSize: ".8em"}} key={layers[0].key}>{layers[0].name}</div>
            <div style={{ height: h+35 }}>
                <Bar data={data[layers[0].key]} options={title_options}/>
            </div>
            {rows}
            { layers.length > 1 && (
                <>
                <div className='axis-label' style={{fontSize: ".8em"}} key={layers[layers.length-1].key}>{layers[layers.length-1].name}</div>
                <div style={{ height: h+20 }}>
                    <Bar data={data[layers[layers.length-1].key]} options={bottomOptions}/>
                </div> 
                </>
            )}
        </div>
    )
}


export default LayerHistogram;